import { Toast } from "vant";
  // 打包前看readme文件
export const mixins = {
  data() {
    return {
      urlList: [
        { time: 0, name: '欲漫涩', url: 'https://d17u485zcy4qn8.cloudfront.net', webUrl: 'https://d1s8wm47asyysy.cloudfront.net' },
        { time: 0, name: '萝莉岛', url: 'https://d6l8cd97c4ld.cloudfront.net', webUrl: 'https://d1q6v0m0fmxvl0.cloudfront.net' },
        { time: 0, name: '麻豆', url: 'https://d39152n22uhzoi.cloudfront.net', webUrl: 'https://d2m1d86x8ze4id.cloudfront.net' },
        { time: 0, name: '海角乱伦', url: 'https://d1l6ywfv3fnf8f.cloudfront.net', webUrl: 'https://doyj68zud8dgm.cloudfront.net' },
        { time: 0, name: 'pornhub中文版', url: 'https://d1e9etuokr8f1r.cloudfront.net', webUrl: 'https://d2o7c2qy2lvgf1.cloudfront.net' },
        { time: 0, name: 'xvideos', url: 'https://d37autknrdu1js.cloudfront.net', webUrl: 'https://d4yzu2s8mrrvk.cloudfront.net' },
        { time: 0, name: '91Porn', url: 'https://ddymsygj2ykcr.cloudfront.net'},
        
        { time: 0, name: '萝莉岛2', url: 'https://d15vtkxnlg8lp5.cloudfront.net', webUrl: 'https://d2xw96fnbwxopk.cloudfront.net'},
        { time: 0, name: '猎奇研究院', url: 'https://985lq.com', webUrl: 'https://985lq.com'},
        { time: 0, name: 'pornhub精品版', url: 'https://d10tmlcshndh4j.cloudfront.net' },
        { time: 0, name: '哆哔涩漫', url: 'https://d23yxaa63x0oz2.cloudfront.net/' },
        { time: 0, name: '糖心视频', url: 'https://d3sy6ecwtbd0t2.cloudfront.net' },
        { time: 0, name: '91暗网', url: 'https://d2lu97vuxcm2vv.cloudfront.net', webUrl: 'https://dh0n7f6bcnjxj.cloudfront.net' },
        { time: 0, name: '好色', url: 'https://d7st7zjax6cw9.cloudfront.net', webUrl: 'https://d39cmeitkp3imu.cloudfront.net' },
        { time: 0, name: 'Soul', url: 'https://d2dagprf0q0opn.cloudfront.net', webUrl: 'https://d1u1x3yp88ozd.cloudfront.net' },
        { time: 0, name: '逼哩逼哩', url: 'https://d2hyz4sj5ufsse.cloudfront.net' },


        { time: 0, name: 'XVideos破解版', url: 'https://d1myb6qv3bowjt.cloudfront.net' },
        { time: 0, name: '波多', url: 'https://dlp4uiv8iuprh.cloudfront.net' },
        { time: 0, name: '妻友', url: 'https://df7zr4kcygkkj.cloudfront.net' },

        { time: 0, name: '91涩漫', url: 'https://de8wg58p1x04l.cloudfront.net' },
        { time: 0, name: '快手', url: 'https://d3kayk2xse8951.cloudfront.net' },
        { time: 0, name: 'tiktok成人版', url: 'https://dshdjwje8e64v.cloudfront.net/', webUrl: 'https://d2tq1xaddgbjfa.cloudfront.net' },
        { time: 0, name: '极乐禁地', url: 'https://d2hktdaco0jyfs.cloudfront.net/' },

        { time: 0, name: '呦乐园', url: 'https://d5fdiqdz5ctfs.cloudfront.net' },
         { time: 0, name: '妖精动漫', url: 'https://d9mh4adpgklfx.cloudfront.net/', webUrl: 'https://d385zn2by94332.cloudfront.net' },

        { time: 0, name: '拔萝卜', url: 'https://dtnp43jfi16mp.cloudfront.net/' },

        { time: 0, name: '91猎奇', url:  'https://ddt8tvyrbbwhs.cloudfront.net/' },
        { time: 0, name: '腾讯涩漫', url: 'https://d7454mf9k4a7k.cloudfront.net/' },
        { time: 0, name: '疯马夜场', url: 'https://d245hhohm8glwv.cloudfront.net/' },

        { time: 0, name: '泡芙视频', url: 'https://dwft40ftdc2vy.cloudfront.net/' },
        { time: 0, name: '黑料社', url: 'https://d3thf6f815xy9e.cloudfront.net/' },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      const routeDc = this.$route.query.dc
      if (routeDc) {
        window.open(url + '?dc=' + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || 985
        window.open(url + '?dc=' + dc);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
